import manageJss from "@microsoft/fast-jss-manager-react";
import { Row as BaseRow, east, north, RowResizeDirection, rowStyleSheet, south, west, } from "./row";
const Row = manageJss(rowStyleSheet)(BaseRow);
export { Row, RowResizeDirection, east, west, north, south, };
